module.exports = __webpack_public_path__ + "img/大数据产业.c6171782.png";